import { TOOL_ACTION } from 'store/selectors/toolSelector';

export enum KEY {
  DRAW = '1',
  EDIT = '2',
  ORIENTATION = '3',
  DELETE_FACET = '4',
  RECALCULATE_LAYOUT = '5',
  EDIT_OBSTRUCTION = '6',
  ADJUST_SHADING = '8',
	EDIT_EDGES = '7',
}

export const KEY_TO_ACTION: Record<KEY, TOOL_ACTION | null> = {
	[KEY.DRAW]: TOOL_ACTION.DRAW_FACET,
	[KEY.EDIT]: TOOL_ACTION.EDIT_FACET,
	[KEY.ORIENTATION]: TOOL_ACTION.CHANGE_ORIENTATION,
	[KEY.DELETE_FACET]: TOOL_ACTION.DELETE_FACET,
	[KEY.RECALCULATE_LAYOUT]: TOOL_ACTION.RECALCULATE_LAYOUT,
	[KEY.EDIT_OBSTRUCTION]: TOOL_ACTION.EDIT_OBSTRUCTION,
	[KEY.ADJUST_SHADING]: TOOL_ACTION.REMOVE_SHADING,
	[KEY.EDIT_EDGES]: TOOL_ACTION.EDIT_EDGES,
};

// in-house mode hides remove-shading, so edit-tree takes over its key instead
export const getActionForKey = (key: KEY, isInHouseMode: boolean): TOOL_ACTION | null => {
	if (isInHouseMode && key === KEY.ADJUST_SHADING) return TOOL_ACTION.EDIT_TREE;
	return KEY_TO_ACTION[key];
};
